import React, { useEffect, useState, useContext } from 'react'
import { Box, Divider, Grid, IconButton } from '@mui/material'
import DefaultPainel from '../../components/shared/Painel'
import AdaptativeGridContainer from '../../components/shared/AdaptativeGridContainer'
import TableHeader from '../../components/shared/tables/TableHeader'
import BasicModal from '../../components/shared/modals/BaseModal'
import FilterButton from '../../components/buttons/FilterButton'
import { Add, DeleteForever, Edit } from '@mui/icons-material'
import { Bibliotecarios } from '../../services/http'
import FormBibliotecario from './components/FormBibliotecario'
import gerarPaginacao from '../../services/pagination'
import { confirmDelete } from '../livros/functions'
import ModalBibliotecario from './components/ModalBibliotecario'
import BaseFilter from '../../components/BaseFilter'
import TableBibliotecario from './styles/TableBibliotecario'
import SmallTextField from '../../components/textfield/SmallTextfield'
import PrivateRC from '../../components/PrivateRC'
import { PermissionsContext } from '../../providers/permissions'
import SearchStartAdornment from '../../components/adornment/SearchStartAdornment'
import SearchEndAdornment from '../../components/adornment/SearchEndAdornment'
import filters from './filters'
import { toast } from 'react-toastify'
import MobileFilterHeaderContainer from '../../components/filters/MobileFilterHeaderContainer'

const OpenButton = ({ ...props }) => (
  <FilterButton
    color="white"
    Icon={Add}
    {...props}
    text="Novo Bibliotecário"
    bg="#000000BF"
  />
)

const Bibliotecario = () => {
  const [status, setStatus] = useState(false)
  const [rows, setRows] = useState([])
  const [queryLibrarian, setQueryLibrarian] = useState([])
  const [currentPage, setCurrentPage] = useState(0)
  const [lastPage, setLastPage] = useState(1)
  const [bibliotecario, setBibliotecario] = useState(null)
  const [tloading, setTloading] = useState(false)
  const [query, setQuery] = useState({})
  const [editando, setEditando] = useState(false)
  const { hasThisPermission } = useContext(PermissionsContext)

  const pagination = gerarPaginacao(true, lastPage, currentPage, (_, value) =>
    getBibliotecarios(query, value)
  )

  let typingTimer = ''

  useEffect(() => {
    init()
  }, [])

  function init() {
    getBibliotecarios()
    setRows([])
  }

  async function getBibliotecarios(filters, page) {
    try {
      setTloading(true)
      const { data } = await Bibliotecarios().show({
        'includes[]': 'user,biblioteca',
        page,
        ...filters
      })
      setCurrentPage(data.current_page)
      setLastPage(data.last_page)
      const aux = data.data.map(item => ({
        ...item,
        bibliotecario: item.user.name,
        email: item.user.email,
        biblioteca: item.biblioteca.apelido
      }))
      setRows(aux)
      setTloading(false)
    } catch (e) {
      toast.error('Falha ao carregar bibliotecários')
      console.warn(e)
    }
  }

  async function deleteBibliotecario(id) {
    try {
      await Bibliotecarios(id).delete()
      getBibliotecarios(query, currentPage)
      toast.success('Bibliotecario cadastrado com sucesso!')
    } catch (e) {
      console.log(e)
      toast.error('falha ao cadastrar bibliotecario')
    }
  }

  function getLector() {
    setQuery(
      Object.assign(query, {
        'includes[user][name]': `%${queryLibrarian?.toUpperCase()}%`
      })
    )
    getBibliotecarios(query)
  }

  function handleClean() {
    if (queryLibrarian !== '') {
      setQueryLibrarian('')
      delete query['includes[user][name]']
      getBibliotecarios({ ...query, 'includes[user][name]': undefined })
    }
  }

  const columns = [
    {
      field: 'biblioteca',
      headerName: 'Biblioteca',
      flex: 1
    },
    {
      field: 'bibliotecario',
      headerName: 'Bibliotecário',
      flex: 4
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 4
    },
    hasThisPermission({ roles: 'gestor' })
      ? {
          field: 'actions',
          headerName: 'Ações',
          flex: 2,
          renderCell: ({ row }) => {
            return (
              <>
                <IconButton
                  sx={{ color: 'rgba(234, 144, 39, 1)' }}
                  onClick={() => {
                    setEditando(true)
                    setBibliotecario(row)
                  }}
                >
                  <Edit />
                </IconButton>
                <IconButton
                  onClick={() => {
                    const msg = `Deseja deletar o bibliotecário ${row.bibliotecario}`
                    confirmDelete(
                      row.id,
                      'bibliotecário',
                      msg,
                      deleteBibliotecario
                    )
                  }}
                  color="error"
                >
                  <DeleteForever />
                </IconButton>
              </>
            )
          }
        }
      : {}
  ].map(item => ({ ...item, sortable: true }))

  return (
    <Box>
      <ModalBibliotecario
        open={editando}
        onClose={value => {
          setEditando(value)
          getBibliotecarios({}, currentPage)
        }}
        data={bibliotecario}
        id_bibliotecario={bibliotecario?.id}
      />
      <DefaultPainel sx={{ mt: '4vh' }}>
        <AdaptativeGridContainer>
          <>
            <TableHeader
              titulo="Bibliotecários"
              controls={
                <MobileFilterHeaderContainer>
                  <PrivateRC roles="bibliotecario">
                    <SmallTextField
                      sx={{ marginRight: '15px' }}
                      type="text"
                      color="white"
                      placeholder="Bibliotecário"
                      variant="standard"
                      onKeyDown={() => {
                        clearTimeout(typingTimer)
                      }}
                      onKeyUp={() => {
                        clearTimeout(typingTimer)
                        typingTimer = setTimeout(getLector, 1000)
                      }}
                      onChange={({ target }) => {
                        setQueryLibrarian(target.value)
                      }}
                      value={queryLibrarian}
                      InputProps={{
                        style: { color: 'white' },
                        startAdornment: <SearchStartAdornment />,
                        endAdornment: (
                          <SearchEndAdornment action={handleClean} />
                        )
                      }}
                    />
                  </PrivateRC>
                  <PrivateRC roles="gestor">
                    <BasicModal
                      title="Novo Bibliotecário"
                      Caller={OpenButton}
                      status={status}
                      closeEvent={event => {
                        setStatus(event)
                      }}
                      sx={{
                        minWidth: '32vw',
                        width: { xs: '100vw', md: '32vw' }
                      }}
                    >
                      <FormBibliotecario
                        submitMethod="post"
                        onSubmitEnd={() => {
                          getBibliotecarios({}, currentPage)
                          setStatus(false)
                        }}
                      />
                    </BasicModal>
                  </PrivateRC>
                  <BaseFilter
                    filter={filters}
                    color="white"
                    onChange={value => {
                      setQuery(Object.assign(query, value))
                      getBibliotecarios(query)
                    }}
                  />
                </MobileFilterHeaderContainer>
              }
            />

            <Grid item xs={12} sm={12}>
              <Divider />
              <TableBibliotecario
                rows={rows}
                columns={columns}
                disableColumnMenu
                pagination={pagination}
                loading={tloading}
              />
            </Grid>
          </>
        </AdaptativeGridContainer>
      </DefaultPainel>
    </Box>
  )
}

export default Bibliotecario
